module.exports = __webpack_public_path__ + "img/hr-car-mask-5.df9f4dab.png";